import { DateWindow } from "../../../api/tenantInternalReports";
import {
  fyToDateWindow,
  lifeToDateWindowForMonth,
  monthLabelToDateWindow,
  priorFyKey,
} from "../../../lib/utils";

interface WindowEntry<T> {
  date_window: DateWindow;
  data: T;
}

const sameBound = (
  a: string | null | undefined,
  b: string | null | undefined
): boolean => (a ?? null) === (b ?? null);

export const pickWindowData = <T>(
  entries: WindowEntry<T>[],
  target: DateWindow
): T | undefined =>
  entries.find(
    (entry) =>
      sameBound(entry.date_window.start_date, target.start_date) &&
      sameBound(entry.date_window.end_date, target.end_date)
  )?.data;

/** Borrowal request windows: the selected month and life-to-date. */
export const buildBorrowalVsNonBorrowalDateWindows = (monthLabel: string): DateWindow[] => [
  monthLabelToDateWindow(monthLabel),
  lifeToDateWindowForMonth(monthLabel),
];

/** Fraud-by-FIC-category request windows: the selected fiscal year and the one before it. */
export const buildFraudByFicCategoryDateWindows = (
  fyKey: string
): DateWindow[] => [fyToDateWindow(fyKey), fyToDateWindow(priorFyKey(fyKey))];
